import { SproToasterService } from "../../services/spro-toaster/spro-toaster.service";
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

/*##################################################################################*
 * COMPOSANT SPRO : spro-periode-liste
 *
 * DESCRIPTION : Sélection d'une date de début et de fin + une valeur dans une liste
 *
 ##################################################################################*/

@Component({
  selector: "spro-periode-liste",
  template: `
    <div class="row premierplan">
      <div class="col-md-3 vcenter autosize-kendo">
        <span> {{ "date.t_deb" | translate }} </span>
        <spro-calendar
          [d_date]="d_startDate"
          [f_affLib]="true"
          (e_change)="proc_newStart($event)"
        ></spro-calendar>
      </div>
      <div class="col-md-3 vcenter autosize-kendo">
        <span> {{ "date.t_fin" | translate }} </span>
        <spro-calendar
          [d_date]="d_endDate"
          [f_affLib]="true"
          (e_change)="proc_newEnd($event)"
        ></spro-calendar>
      </div>

      <div class="col-md-5">
        <spro-dropdownlist
          [h_data]="h_list"
          [w_texteChamp]="w_texteChamp"
          [w_valeurChamp]="w_valeurChamp"
          (e_valueChange)="proc_dropChange($event)"
        >
        </spro-dropdownlist>
      </div>

      <div class="col-md-1 vcenter autosize-kendo">
        <spro-button-actualiser (e_click)="proc_refresh()">
        </spro-button-actualiser>
      </div>
    </div>
  `
})
export class spro_cls_periode_liste {
  /** Date de début de période (pour initialisation) */
  @Input() d_startDate: Date;
  /** Date de fin de période (pour initialisation) */
  @Input() d_endDate: Date;
  /** Liste pour dropdown */
  @Input() h_list: Array<any> = [];
  /** Libellé des champs de la liste */
  @Input() w_texteChamp: string;
  /** Clef des champs de la liste */
  @Input() w_valeurChamp: string;
  /** Message si pas de valeur sélectionné dans la liste */
  @Input() w_erreurListe: string = "Messages.erreur_liste";

  /** Déclaration événement sur click */
  @Output() e_actualiser: EventEmitter<any> = new EventEmitter();

  /** Valeur sélectionné dans la liste */
  public w_valCombo: any = null;

  /**
   * Constructeur
   */
  constructor(
    public s_translate: TranslateService,
    public s_toaster: SproToasterService
  ) {}

  /**
   * Evénements sur changement de la date de début
   */
  public proc_newStart(value): void {
    this.d_startDate = value;

    if (!this.proc_verify_dates(this.d_startDate, this.d_endDate))
      this.s_toaster.proc_toastTradError("date.msg_dtdeb_lib");
  }

  /**
   * Evénements sur changement de la date de fin
   */
  public proc_newEnd(value): void {
    this.d_endDate = value;

    if (!this.proc_verify_dates(this.d_startDate, this.d_endDate))
      this.s_toaster.proc_toastTradError("date.msg_dtfin_lib");
  }

  /**
   * Controle des dates (début < fin)
   */
  public proc_verify_dates(start, end): Boolean {
    if (start <= end) return true;
    else return false;
  }

  /**
   * Evénements sur changement de valeur de combo
   */
  public proc_dropChange(value): void {
    if (value == null) this.w_valCombo = null;
    else this.w_valCombo = value[this.w_valeurChamp];
  }

  /**
   * Actualisation
   */
  public proc_refresh(): void {
    if (!this.proc_verify_dates(this.d_startDate, this.d_endDate)) {
      this.s_toaster.proc_toastTradError("date.msg_dtfin_lib");
      return;
    }

    if (this.w_valCombo == null) {
      this.s_toaster.proc_toastTradError(this.w_erreurListe);
      return;
    }

    const h_data = {
      start: this.d_startDate,
      end: this.d_endDate,
      valListe: this.w_valCombo
    };
    this.e_actualiser.emit(h_data);
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/utils/spro-periode-liste/spro-periode-liste.component.ts